var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEmailVerifiedTickIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6976 1.6665C6.10592 1.6665 2.36426 5.40817 2.36426 9.99984C2.36426 14.5915 6.10592 18.3332 10.6976 18.3332C15.2893 18.3332 19.0309 14.5915 19.0309 9.99984C19.0309 5.40817 15.2893 1.6665 10.6976 1.6665ZM14.6809 8.08317L9.95592 12.8082C9.83926 12.9248 9.68092 12.9915 9.51426 12.9915C9.34759 12.9915 9.18926 12.9248 9.07259 12.8082L6.71426 10.4498C6.47259 10.2082 6.47259 9.80817 6.71426 9.5665C6.95592 9.32484 7.35592 9.32484 7.59759 9.5665L9.51426 11.4832L13.7976 7.19984C14.0393 6.95817 14.4393 6.95817 14.6809 7.19984C14.9226 7.4415 14.9226 7.83317 14.6809 8.08317Z",
    fill: "#2ABF86"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmailVerifiedTickIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/email-verified-tick-icon.4b7caf84.svg";
export { ForwardRef as ReactComponent };